import generalApprove from './components/flow-general-audit.vue';
var Plugin = {
  install: function install(Vue) {
    Vue.component('general-approve', generalApprove);
  }
};
export { generalApprove as GeneralApprove };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/general-approve/index.js
// module id = 5
// module chunks = 0